import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../../service/data-provider.service';

@Component({
  selector: 'app-acknowled',
  templateUrl: './acknowled.component.html',
  styleUrls: ['./acknowled.component.css']

})
export class AcknowledComponent implements OnInit {

  Acknowled = [];
  constructor(private datapro: DataProviderService) {
    this.datapro.acknowled.Acknowled.forEach(element => {
      this.Acknowled.push(element.Aclogo);
    });
  }

  ngOnInit() {
  }

}
